export default __webpack_public_path__ + "static/media/LinkedIn.b416df2d.svg";